import {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';

import { selectWorkshopProductByName } from '@/redux/selectors/workshopSelectors';
import { useAppSelector } from '@/redux/store';

import { type GoodsType } from '../types/goods';
import { type ProductData, type UserWorkshop } from '../types/workshopType';

interface useActiveWorkshopGoodsReturnType {
  activeGoodsName: GoodsType | undefined;
  setActiveGoodsName: Dispatch<SetStateAction<GoodsType | undefined>>;
  activeGoods?: ProductData;
}

const useActiveWorkshopGoods = (
  workshop?: UserWorkshop | undefined,
  stateGoodsName?: GoodsType,
): useActiveWorkshopGoodsReturnType => {
  const { id } = useParams();
  const [activeGoodsName, setActiveGoodsName] = useState<GoodsType | undefined>(
    stateGoodsName ||
      workshop?.targetProduct ||
      workshop?.products[0].name ||
      undefined,
  );
  const activeGoods = useAppSelector((state) =>
    selectWorkshopProductByName(state, {
      workshopId: id,
      goodsName: activeGoodsName,
    }),
  );
  const prevWorkshopId = useRef<string | undefined>();

  useEffect(() => {
    if (workshop) {
      setActiveGoodsName((state) => {
        if (
          workshop.targetProduct === null &&
          state &&
          prevWorkshopId.current === workshop.id
        ) {
          return state;
        } else {
          return (
            stateGoodsName ||
            workshop.targetProduct ||
            workshop.products[0].name ||
            undefined
          );
        }
      });
    }

    return (): void => {
      prevWorkshopId.current = workshop?.id;
    };
  }, [stateGoodsName, workshop]);

  return {
    activeGoodsName,
    setActiveGoodsName,
    activeGoods,
  };
};

export { useActiveWorkshopGoods };
